import { type FC } from 'react';

import { useTranslation } from 'react-i18next';

import { HOME_HERO_IMAGE } from '@/shared/configs/hero.config';

import { OutlineButton } from '@/components/common/OutlineButton';
import { HeroBackground } from '@/components/hero/HeroBackground';

interface HomeHeroProps {
  scrollTo: string;
  isLoading?: boolean;
}

export const HomeHero: FC<HomeHeroProps> = ({ scrollTo, isLoading = false }) => {
  const { t } = useTranslation();

  return (
    <HeroBackground image={HOME_HERO_IMAGE} alt={t('home.heroImageAlt')}>
      <h1 className="px-6 text-center text-2xl font-bold text-white max-lg:max-w-2xl md:text-3xl lg:text-4xl">
        {t('home.heroTitle')}
      </h1>
      {isLoading ? (
        <p className="h-10 text-center text-white">{t('common.loading')}</p>
      ) : (
        <OutlineButton size="lg" asChild>
          <a
            href={`#${scrollTo}`}
            onClick={(e) => {
              e.preventDefault();
              document.getElementById(scrollTo)?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            {t('home.heroButtonText')}
          </a>
        </OutlineButton>
      )}
    </HeroBackground>
  );
};
